import React from 'react';
import { MilestoneTab } from '../Connect25/AwardsAccordion';

const Achievement = () => {
  return (
    <div className="p-4 md:p-6 lg:p-8 max-w-[1400px] mx-auto w-full">
      <MilestoneTab />
    </div>
  );
};

export default Achievement;
